function initOfferCarousel(root) {
  if (root.dataset.offerBound) return;
  root.dataset.offerBound = '1';

  const track = root.querySelector('[data-offer-track]');
  const dots = Array.from(root.querySelectorAll('[data-offer-dot]'));
  const cards = track ? Array.from(track.children) : [];
  if (!track || cards.length < 2) return;

  const calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function nearest() {
    // The card whose left edge is closest to the track's, so a part-scrolled
    // row still reports the slide the reader is actually looking at.
    const left = track.scrollLeft;
    let best = 0;
    let bestGap = Infinity;
    cards.forEach((card, i) => {
      const gap = Math.abs(card.offsetLeft - track.offsetLeft - left);
      if (gap < bestGap) {
        bestGap = gap;
        best = i;
      }
    });
    return best;
  }

  function goTo(index) {
    // Wraps at both ends, the way the slider this replaces looped.
    const target = cards[(index + cards.length) % cards.length];
    track.scrollTo({
      left: target.offsetLeft - track.offsetLeft,
      behavior: calm.matches ? 'auto' : 'smooth',
    });
  }

  function sync() {
    const active = nearest();
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
  }

  dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
  root.querySelector('[data-offer-prev]')?.addEventListener('click', () => goTo(nearest() - 1));
  root.querySelector('[data-offer-next]')?.addEventListener('click', () => goTo(nearest() + 1));

  let frame = null;
  track.addEventListener('scroll', () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      sync();
    });
  });

  // Drag to swipe. Touch and trackpads already scroll the track natively, so
  // this only takes over for a mouse — otherwise it would fight the browser's
  // own momentum and snapping.
  let armed = false;
  let captured = false;
  let startX = 0;
  let startScroll = 0;
  let startIndex = 0;
  let moved = 0;

  track.addEventListener('pointerdown', (event) => {
    moved = 0;
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    armed = true;
    startX = event.clientX;
    startScroll = track.scrollLeft;
    startIndex = nearest();
  });

  track.addEventListener('pointermove', (event) => {
    if (!armed) return;
    const delta = event.clientX - startX;
    if (!captured) {
      if (Math.abs(delta) <= 4) return;
      // Capture only once the pointer has actually travelled. Taking it on
      // pointerdown retargets the click to the track, which swallows every
      // plain click on "Reveal code".
      captured = true;
      track.setPointerCapture(event.pointerId);
      // Snapping is off mid-drag so the track follows the pointer instead of
      // being pulled back to the nearest slide on every frame.
      track.classList.add('is-dragging');
    }
    moved = delta;
    track.scrollLeft = startScroll - delta;
  });

  function endDrag(event) {
    if (!armed) return;
    armed = false;
    if (!captured) return;
    captured = false;
    if (track.hasPointerCapture?.(event.pointerId)) track.releasePointerCapture(event.pointerId);
    track.classList.remove('is-dragging');
    // A drag past a tenth of the track counts as a swipe and advances one
    // slide; anything shorter settles back onto the slide it started from.
    const step = Math.abs(moved) > track.clientWidth * 0.1 ? Math.sign(moved) : 0;
    goTo(startIndex - step);
  }

  track.addEventListener('pointerup', endDrag);
  track.addEventListener('pointercancel', endDrag);

  // Suppress the click that follows a real drag so releasing over "Reveal code"
  // does not open a modal the reader never aimed at.
  track.addEventListener(
    'click',
    (event) => {
      if (Math.abs(moved) > 4) {
        event.stopPropagation();
        event.preventDefault();
        moved = 0;
      }
    },
    true
  );

  track.addEventListener('dragstart', (event) => event.preventDefault());

  sync();
}

function initAllOfferCarousels() {
  document.querySelectorAll('[data-offer-carousel]').forEach(initOfferCarousel);
}
initAllOfferCarousels();
document.addEventListener('shopify:section:load', initAllOfferCarousels);

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-offer-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.offerOpen);
    if (dialog) dialog.showModal();
    return;
  }

  const dialog = event.target.closest('.offer-modal');
  if (!dialog) return;

  if (event.target.closest('[data-offer-close]')) {
    dialog.close();
    return;
  }

  // Clicking the backdrop lands on the dialog element itself, never a child.
  if (event.target === dialog) {
    dialog.close();
    return;
  }

  const copier = event.target.closest('[data-offer-copy]');
  if (copier) {
    navigator.clipboard
      ?.writeText(copier.dataset.offerCopy)
      .then(() => {
        const original = copier.textContent;
        copier.textContent = 'Copied';
        setTimeout(() => {
          copier.textContent = original;
        }, 2000);
      })
      .catch(() => {});
  }
});
